export enum TaskCategoryId {
  SubmissionRequirement = 2,
  ProfileReadiness = 5,
}
